import {AxiosInstance, AxiosRequestConfig, AxiosResponse} from 'axios';
import axios from 'axios';
import LoginResponseInterface from '@/types/LoginResponse';
import {Credentials} from '@/util/Credentials';

class Client {
  private axios: AxiosInstance;
  private credentials: Credentials;
  private token?: string;
  public deserialize = true;

  constructor(axios: AxiosInstance, credentials: Credentials) {
    this.axios = axios;
    this.credentials = credentials
  }

  public async get<T = any>(
    action: string,
    config?: AxiosRequestConfig,
    deserialize?: boolean
  ): Promise<T> {
    if (!this.token) {
      await this.login()
    }

    const response: AxiosResponse<T> = await this.axios.get<T>(action, config);

    const isDeserializeSet = deserialize != undefined;

    if (isDeserializeSet && deserialize || !isDeserializeSet && this.deserialize) {
      return new Promise((resolve) => {
        resolve(Client.deserializeData<T>(response));
      });
    }

    return response.data;
  }

  public async post<T = any>(
    action: string,
    data: any,
    config?: AxiosRequestConfig,
    deserialize?: boolean
  ): Promise<T> {
    if (!this.token) {
      await this.login()
    }

    const response: AxiosResponse<T> = await this.axios.post<T>(action, data, config);

    const isDeserializeSet = deserialize != undefined;

    if (isDeserializeSet && deserialize || !isDeserializeSet && this.deserialize) {
      return new Promise((resolve) => {
        resolve(Client.deserializeData<T>(response));
      });
    }

    return response.data;
  }

  public async put<T = any>(
    action: string,
    data: any,
    config?: AxiosRequestConfig,
    deserialize?: boolean
  ): Promise<T> {
    if (!this.token) {
      await this.login()
    }

    const response: AxiosResponse<T> = await this.axios.put<T>(action, data, config);

    const isDeserializeSet = deserialize != undefined;

    if (isDeserializeSet && deserialize || !isDeserializeSet && this.deserialize) {
      return new Promise((resolve) => {
        resolve(Client.deserializeData<T>(response));
      });
    }

    return response.data;
  }

  public async delete<T = any>(action: string, config?: any, deserialize?: boolean): Promise<T> {
    if (!this.token) {
      await this.login()
    }

    const response: AxiosResponse<T> = await this.axios.delete<T>(action, config);

    const isDeserializeSet = deserialize != undefined;

    if (isDeserializeSet && deserialize || !isDeserializeSet && this.deserialize) {
      return new Promise((resolve) => {
        resolve(Client.deserializeData<T>(response));
      });
    }

    return response.data;
  }

  static deserializeData<T>(response: AxiosResponse<T>): T {
    const JSONAPIDeserializer = require('ts-jsonapi').Deserializer;
    return new JSONAPIDeserializer({keyForAttribute: 'camelCase'}).deserialize(
      response.data
    );
  }

  public async login() {
    const response: AxiosResponse<LoginResponseInterface> = await this.axios.post<LoginResponseInterface>('/auth/login', this.credentials);

    this.token = `Bearer ${response.data.token}`;

    this.axios.defaults.headers = {Authorization: this.token};
  }

  set url(url: string | undefined) {
    this.axios.defaults.baseURL = url;
  }

  get url(): string | undefined {
    return this.axios.defaults.baseURL;
  }
}

class ClientFactory {
  static createApiClient(url?: string): Client {
    const credentials = new Credentials('WebComponent@wambo.com', 'WebComponent')

    const axiosInstance = axios.create({
      baseURL: url || 'https://dev.cvents.eu/api'
    });

    return new Client(axiosInstance, credentials);
  }
}

export {Client, ClientFactory};
